import styled from 'styled-components';
import reset from '../reset';
import em from '../em';

export default styled.p`
  ${reset()}
  marginBottom: ${em(1)};
`;
